import { persistCombineReducers } from 'redux-persist'
import storage from 'redux-persist/es/storage';
import auth from './auth';
import dashboard from './dashboard';
import regions from './regions';
import areas from './areas';
import servers from './servers';
import guk_servers from './guk_servers';


const storageConfig = { whitelist: 'auth', key: 'lms2.0_clients', storage };


export default persistCombineReducers(storageConfig, { auth, dashboard, servers, guk_servers, regions, areas })